/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
    Button,
    getPayloadObject,
    getTelemetryAttributes,
    IPayLoad,
    ITelemetryContent,
    TelemetryConstant
} from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IMfrmStoreSelectorResources, IShowAllStoresExternalLinkData } from '../mfrm-store-selector.props.autogenerated';
export interface IStoreSelectorSeeAllStoresProps {
    resources: IMfrmStoreSelectorResources;
    showAllStores?: boolean;
    enableOOBShowAllStores?: boolean;
    showAllStoresExternalLink?: IShowAllStoresExternalLinkData;
    /** The telemetry content */
    telemetryContent?: ITelemetryContent;
    onShowAllStores(): void;
}

/**
 * Displays Button for See All Stores
 */
export class StoreSelectorSeeAllStores extends React.PureComponent<IStoreSelectorSeeAllStoresProps> {
    private showAllStoreAttributes: Msdyn365.IDictionary<string> | undefined;

    constructor(props: IStoreSelectorSeeAllStoresProps) {
        super(props);
        const payLoad: IPayLoad = getPayloadObject('click', props.telemetryContent!, TelemetryConstant.SearchStore);
        payLoad.contentAction.etext = TelemetryConstant.ShowAllStore;
        this.showAllStoreAttributes = getTelemetryAttributes(props.telemetryContent!, payLoad);
    }

    private _showAllStoresTracking () {
        if ('utag' in window) {
            const pageURL = MsDyn365.isBrowser && window.location.pathname;
            // @ts-ignore
            utag.link({
                event: "store-locator-slideout-see-all-stores",
                event_category: "store locator slideout",
                event_action: "see all stores button click",
                event_label: `from: ${pageURL}`,
                event_noninteraction: "false"
            });
        }
    }

    public render(): JSX.Element | null {
        const { showAllStores, onShowAllStores, enableOOBShowAllStores, showAllStoresExternalLink } = this.props;

        return (
            <>
                {showAllStores && (enableOOBShowAllStores || showAllStoresExternalLink?.linkUrl.destinationUrl) && (
                    <div className='ms-store-select__search-see-all-stores'>
                        {enableOOBShowAllStores && (
                            <Button
                                className='ms-store-select__search-see-all-stores-button'
                                onClick={onShowAllStores}
                                {...this.showAllStoreAttributes}
                            >
                                {' '}
                                {this.props.resources.seeAllStoresText}{' '}
                            </Button>
                        )}
                        {!enableOOBShowAllStores && showAllStoresExternalLink?.linkUrl.destinationUrl && (
                            <Button
                                className='ms-store-select__search-see-all-stores-button'
                                href={showAllStoresExternalLink?.linkUrl.destinationUrl}
                                target={showAllStoresExternalLink?.openInNewTab ? '_blank' : '_self'}
                                onClick={this._showAllStoresTracking}
                            >
                                {showAllStoresExternalLink?.linkText}
                            </Button>
                        )}
                    </div>
                )}
            </>
        );
    }
}
